import * as Yup from 'yup';

export const replyYupValidation = () => {
  return Yup.object().shape({
    reply: Yup.string().required('required'),
  });
};

export const playgroundYupValidation = () => {
  return Yup.object().shape({
    message: Yup.string().required('required'),
    fileText: Yup.string(),
    assistant: Yup.object()
      .test('has-either-value-or-label', 'required', (value) => value && (value.value || value.label))
      .required('required'),
  });
};
